import React from 'react'

import dateformat from 'dateformat'

import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItem from '@material-ui/core/ListItem'
import Avatar from '@material-ui/core/Avatar'
import CircularProgress from '@material-ui/core/CircularProgress'

import ExtensionIcon from '@material-ui/icons/Extension'
import GridOnIcon from '@material-ui/icons/GridOn'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import WhiteStoneIcon from '@material-ui/icons/PanoramaFishEye'
import BlackStoneIcon from '@material-ui/icons/Lens'

import { RenjuBoard, Word } from '../../../containers'
import { ConfirmDialog } from '../../../components'
import * as constants from '../../../constants'
import { webBoard as limit } from '../../../constants/Limit'
import { makeGameResultStr, getTurnTypeText, getPuzzleTypeText, getLevelIcon } from '../../../lib';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'
import { useEffect } from 'react'
import { useState } from 'react'

const GameInfoTypography = (props) => {
  const { theme, title, blackPlayerName, whitePlayerName, gameEndNumber, gameResult } = props
  var gameResultStr, stoneIcon
  const style = {
    playerBox: {
      marginBottom: theme.spacing.unit,
    },
    typography: {
    },
    stoneIcon: {
      fontSize: '0.75em',
      color: theme.palette.grey[800],
      marginRight: theme.spacing.unit / 2,
    },
    title: {
      marginBottom: theme.spacing.unit,
    },
    flexBox: {
      display: 'flex',
      alignItems: 'center',
    },
    gameInfoBox: {
      marginTop: theme.spacing.unit,
    },
  }
  if (gameEndNumber !== undefined && gameResult !== undefined) {
    gameResultStr = makeGameResultStr(gameEndNumber, gameResult)
    stoneIcon = gameEndNumber.indexOf('black') ? 
      <WhiteStoneIcon style={style.stoneIcon}/> : <BlackStoneIcon style={style.stoneIcon}/>
  }
  return (
    <div style={style.gameInfoBox}>
      <Typography style={style.title}>{title}</Typography>
      {(blackPlayerName || whitePlayerName) && (
        <div style={style.playerBox}>
          {blackPlayerName && (
            <div style={style.flexBox}>
              <BlackStoneIcon style={style.stoneIcon}/>
              <Typography noWrap style={style.typography}>{blackPlayerName}</Typography>
            </div>
          )}
          {whitePlayerName && (
            <div style={style.flexBox}>
              <WhiteStoneIcon style={style.stoneIcon}/>
              <Typography noWrap style={style.typography}>{whitePlayerName}</Typography>
            </div>
          )}
        </div>
      )}
      {gameResultStr && (
        <div style={style.flexBox}>
          {stoneIcon}
          <Typography noWrap style={style.typography}>{gameResultStr}</Typography>
        </div>
      )}
    </div>
  )
}

const PuzzleInfoTypography = (props) => {
  const { theme, turn, level, type } = props
  
  const style = {
    puzzleInfoBox: {
      marginTop: theme.spacing.unit,
    },
  }
  
  return (
    <div style={style.puzzleInfoBox}>
      <Typography>{getTurnTypeText(turn)} {getPuzzleTypeText(type)}</Typography>
      <Typography>{getLevelIcon(level, 0, 'text')}</Typography>
    </div>
  )
}

const recordStyles = theme => ({
  boardGrid: {
    paddingLeft: theme.spacing.unit,
  },
  infoGrid: {
    paddingLeft: theme.spacing.unit
  },
  listItem: {
    padding: theme.spacing.unit
  },
  avatarIcon: {
    color: 'white'
  },
  allowDropIcon: {
    marginLeft: theme.spacing.unit,
    fontSize: '1em',
    color: theme.palette.grey[800],
  },
  datetime: {
    color: theme.palette.grey[500],
  },
  title: {
    fontSize: '0.875em',
  }
})

class Record extends React.Component {
  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes, theme, id, title, updateDatetime, createDatetime, boardContext, isEditing, isEdited, recordMenuProps } = this.props
    const { open } = this.state
    var style = {
      rootGrid: {
        backgroundColor: isEditing ? theme.palette.grey[100] : undefined,
      },
      listGrid: {
        paddingLeft: theme.spacing.unit,
      }
    }
    return (
      <Grid container spacing={0} style={style.rootGrid}>
        <Grid item xs={12} style={style.listGrid}>
          <ListItem className={classes.listItem}>
            <Avatar>
              {boardContext.editMode === constants.editModeType.NORMAL ? (
                <GridOnIcon className={classes.avatarIcon}/>
              ) : (
                <ExtensionIcon className={classes.avatarIcon}/>
              )}
            </Avatar>
            <ListItemText
              primary={title ? title : 'Untitled'}
              secondary={
                <Typography className={classes.datetime}>
                  {dateformat(updateDatetime ? updateDatetime : createDatetime, 'yyyy/m/d H:MM')}
                  {open ?
                    (<ArrowDropUpIcon className={classes.allowDropIcon}/>) : 
                    (<ArrowDropDownIcon className={classes.allowDropIcon}/>)
                  }
                </Typography>
              }
              onClick={open ? this.handleClose : this.handleOpen}
            />
            <RecordMenu
              onEdit={recordMenuProps.handleEdit(id, boardContext)}
              onDelete={recordMenuProps.handleDelete(id, isEditing)}
              isEdited={isEdited}
            />
          </ListItem>
        </Grid>
        <Grid item xs={6} className={classes.boardGrid} onClick={this.handleClose}>
          <Collapse in={open}>
            <RenjuBoard
              type='View'
              moves={boardContext.moves}
              isVisibleNumber={true}
            />
          </Collapse>
        </Grid>
        <Grid item xs={6} className={classes.infoGrid} onClick={this.handleClose}>
          <Collapse in={open}>
            {boardContext.editMode === constants.editModeType.NORMAL && boardContext.gameInfo && (
              <GameInfoTypography {...boardContext.gameInfo} theme={theme}/>
            )}
            {boardContext.editMode === constants.editModeType.PUZZLE && boardContext.puzzleInfo && (
              <PuzzleInfoTypography {...boardContext.puzzleInfo} theme={theme}/>
            )}
          </Collapse>
        </Grid>
      </Grid>
    )
  }
}

Record = withStyles(recordStyles, { withTheme: true })(Record)

const recordMenuStyles = theme => ({
})

class RecordMenu extends React.Component {
  state = {
    anchorEl: null,
    openConfirmDialog: false,
    openEditCnfDlg: false,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleClickEdit = () => {
    if (this.props.isEdited === true) {
      this.setState({ openEditCnfDlg: true })
    }
    else {
      if (this.props.onEdit) {
        this.props.onEdit()
        window.scrollTo(0, 0)
      }
    }
    this.setState({ anchorEl: null })
  }

  handleClickDelete = () => {
    this.setState({ openConfirmDialog: true })
    this.setState({ anchorEl: null })
  }

  confirmDialogProps = {
    handleClose: () => {
      this.setState({ openConfirmDialog: false })
    },
    handleOK: () => {
      if (this.props.onDelete) {
        this.props.onDelete()
      }
      this.setState({ openConfirmDialog: false })
    }
  }

  editCnfDlgProps = {
    handleClose: () => {
      this.setState({ openEditCnfDlg: false })
    },
    handleOK: () => {
      if (this.props.onEdit) {
        this.props.onEdit()
      }
      this.setState({ openEditCnfDlg: false })
    }
  }

  render() {
    const { anchorEl, openConfirmDialog, openEditCnfDlg } = this.state
    return (
      <React.Fragment>
        <IconButton onClick={this.handleOpen}>
          <MoreVertIcon/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClickEdit}>
            <ListItemIcon><EditIcon/></ListItemIcon>
            <ListItemText inset primary={<Word wid={WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT}/>} />
          </MenuItem>
          <MenuItem onClick={this.handleClickDelete}>
            <ListItemIcon><DeleteIcon/></ListItemIcon>
            <ListItemText inset primary={<Word wid={WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.DELETE}/>} />
          </MenuItem>
        </Menu>
        <ConfirmDialog
          title={<Word wid={WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.DELETE_CONFIRM_DIALOG.TITLE}/>}
          open={openConfirmDialog}
          onClose={this.confirmDialogProps.handleClose}
          onOK={this.confirmDialogProps.handleOK}
        />
        <ConfirmDialog
          title={<Word wid={WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT_CONFIRM_DIALOG.TITLE}/>}
          content={<Word wid={WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT_CONFIRM_DIALOG.CONTENT}/>}
          open={openEditCnfDlg}
          onClose={this.editCnfDlgProps.handleClose}
          onOK={this.editCnfDlgProps.handleOK}
        />
      </React.Fragment>
    )
  }
}

RecordMenu = withStyles(recordMenuStyles, { withTheme: true })(RecordMenu)

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 680,
    margin: '0 auto',
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  cardHeaderAction: {
    margin: `auto ${theme.spacing.unit}px auto 0`,
  },
  cardContent: {
    padding: `${theme.spacing.unit}px 0`,
    maxHeight: 400,
    overflowY:'scroll',
  },
  recordLength: {
    color: theme.palette.grey[500]
  },
  circularProgress: {
    display: 'flex', justifyContent: 'center', padding: theme.spacing.unit * 4,
  },
  noRecord: {
    padding: theme.spacing.unit * 2,
  }
})

function StoreBoardCard(props) {
  const { classes, records, editingBoardId, isEdited, recordMenuProps, ready } = props
  
  const auth0Context = useContext(Auth0Context)
  const [listenerID, setListenerID] = useState()
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (auth0Context.user) {
      props.init()
      setIsInitialized(true)
    }
    setListenerID(auth0Context.onAuthStateChanged(user => {
      if (user && !isInitialized) {
        props.init()
      }
    }))
    return () => {
      if (listenerID) {
        auth0Context.unregisterAuthStateChanged(listenerID)
      }
    }
  }, [])

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardHeader
          subheader={<Typography><Word wid={WID.STORE_BOARD_CARD.TITLE}/></Typography>}
          className={classes.cardHeader}
          action={<Typography className={classes.recordLength}>{`${records.length}/${limit.maxRecordLength}`}</Typography>}
          classes={{action: classes.cardHeaderAction}}
        />
        <CardContent className={classes.cardContent}>
          {ready === false ? (
            <div className={classes.circularProgress}>
              <CircularProgress />
            </div>
          ) : records.length > 0 ? (records.map((record, index) =>
            <Record
              key={index}
              {...record}
              {...{recordMenuProps}}
              isEditing={record.id === editingBoardId}
              isEdited={isEdited}
            />
          )) : (
            <div className={classes.noRecord}>
              <Typography><Word wid={WID.STORE_BOARD_CARD.NO_FILES}/></Typography>
            </div>
          )}
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(StoreBoardCard)


// WEBPACK FOOTER //
// ./src/Pages/WebBoard/components/StoreBoardCard.js